var _desc, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditText3925(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Edit Text") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A line styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer2",
    d: "M31.4 58H4a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h9.9M34 8h10a2 2 0 0 1 2 2v29",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2.8,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer2",
    d: "M32 6h-3.1a5 5 0 0 0-9.8 0H16a2 2 0 0 0-2 2v6h20V8a2 2 0 0 0-2-2zm6 40.9V14h-4m-20 0h-4v36h24.9M18 22h12M18 32h12M18 42h12",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2.8,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer1",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2.8,
    d: "M55 30L34.2 50.7 29.8 62l11.4-4.3L62 37l-7-7zM34.2 50.7l7 7",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditText3925);
export default __webpack_public_path__ + "static/media/edit-text-3925.f3247520e3a1d936c6ccc3033918abdf.svg";
export { ForwardRef as ReactComponent };